<script lang="ts">
	import { format } from 'svelte-i18n';
	import TemplateToggleSettings from '../Components/TemplateToggleSettings.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<TemplateToggleSettings
	{device}
	setting="power_down_memory"
	title={$format('settings_title_power_down_memory', {
		default: 'Enable power down memory',
	})}
/>
